import React, { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  className?: string;
}

const Input: React.FC<InputProps> = ({ 
  label, 
  id, 
  error, 
  className = "", 
  required,
  ...props 
}) => {
  return (
    <div className="w-full">
      {label && (
        <label 
          htmlFor={id} 
          className="block mb-2 ml-1 text-xs font-bold tracking-wider text-gray-500 uppercase"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        id={id}
        required={required}
        className={`w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:bg-white focus:border-[#4CE470] focus:ring-4 focus:ring-[#4CE470]/10 transition-all font-medium text-[#113A28] ${
          error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/10' : ''
        } ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1 ml-1 text-xs font-medium text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
